export const FILE_PREVIEW_EXTENSIONS = {
  AUDIO_FORMATS: ["mp3", "wav", "ogg"],
  EXCEL_PREVIEW: ["csv", "xls", "xlsx", "ods"],
  SUPPORTED_TEXT_PREVIEW: [
    "txt",
    "js",
    "py",
    "xml",
    "html",
    "config",
    "log",
    "css",
    "md",
    "yaml",
    "yml"
  ],
  PDF_PREVIEW: ["pdf"]
};

export const FILEPREVIEW_PLUGINS = {
  DOWNLOAD: "download",
  NEWTAB: "newtab",
  PIP: "pip",
  FULLSCREEN: "fullscreen",
  SPLITVIEW: "splitview"
};
